module.exports = __webpack_public_path__ + "static/img/图片2.cf954056.png";